import { Grid, makeStyles } from '@material-ui/core';

import { StoreFooter } from 'shared/presentation/components/organisms';
import { AppNavbar } from 'shared/presentation/components/templates';

import Locals from './Locals';
import PortabilitySession from './PortabilitySession';
import TechSession from './TechSession';
import TopWhoWeAre from './TopWhoWeAre';
import VideoSession from './VideoSession';
import FloatingNav from '../home/FloatingNav';
import MetaTags from '../packages/MetaTags';

const useStyles = makeStyles(theme => ({
  portability: {
    height: '70vh',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      height: '100%',
    },
  },
}));

export default function WhoWeAre() {
  const classes = useStyles();

  return (
    <>
      <AppNavbar />

      <MetaTags canonical={`https://vialaser.com.br/quem-somos`} />
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <TopWhoWeAre />
        </Grid>
        <Grid item xs={12}>
          <Locals />
        </Grid>
        <Grid id="technology" item xs={12}>
          <TechSession />
        </Grid>
        <Grid id="genre" item xs={12}>
          <VideoSession />
        </Grid>
        <Grid id="portability" item xs={12} className={classes.portability}>
          <PortabilitySession />
        </Grid>
        <FloatingNav />
      </Grid>

      <StoreFooter />
    </>
  );
}
